var messages = {
  placeholder: 'Please select',
  noOptions: 'No Data ~'
};
export default messages;